import React from 'react';
import './sections-list.styles.css';
import SectionCard  from '../section-card/section-card.component';

 const CardList = props => (
    <div className='card-list'>
    	{props.books.map(book => (
            <SectionCard key={book.id} book = {book} viewFunc={props.bookToView}/>
        ))}    
    </div>
);
export default CardList;